<template>
  <v-container class="pa-0">
    <div class="text-center mb-4">
      <h1 class="mb-0"><span>👋</span>{{ $t("rollOffWizard.contact.title") }}</h1>
      <p class="mb-1">{{ $t("rollOffWizard.contact.subtitle") }}</p>
      <div class="secondary--text subtitle-2 mt-1 mb-0"><span class="red--text">*</span> {{ $t("rollOffWizard.contact.requiredFields") }}</div>
    </div>
    <v-form ref="contactForm" v-model="contactFormValid" class="my-6" style="max-width:500px; margin-left:auto; margin-right:auto;">
      <v-row>
        <v-col class="my-0 py-0" cols="12">
            <v-card-text class="px-0 py-0 mb-1 text-label">
                <span class="red--text">*</span> {{$t("firstName")}}
            </v-card-text>
            <v-text-field flat dense name="first_name" :placeholder="$t('firstNamePlaceholder')" v-bind:rules="formRules.firstNameRules" v-bind:disabled="loading" v-model="form.firstName" class="rounded-lg input-label" solo outlined prepend-inner-icon="mdi-account" color="grey"></v-text-field>
        </v-col>
        <v-col class="my-0 py-0" cols="12">
            <v-card-text class="px-0 py-0 mb-1 text-label">
                <span class="red--text">*</span> {{ $t("lastName") }}
            </v-card-text>
            <v-text-field flat dense class="rounded-lg input-label" name="last_name" :placeholder="$t('lastNamePlaceholder')" v-bind:disabled="loading" v-model="form.lastName" v-bind:rules="formRules.lastNameRules" solo outlined prepend-inner-icon="mdi-account" color="grey"></v-text-field>
        </v-col>
        <v-col class="my-0 py-0" cols="12">
            <v-slide-x-transition hide-on-leave class="slide-fade-enter-active">
            </v-slide-x-transition>
            <v-slide-x-transition hide-on-leave>
                <v-card-text class="px-0 py-0 mb-1 text-label">
                    <span class="red--text">*</span> {{ $t("email") }}
                </v-card-text>
            </v-slide-x-transition>
            <v-slide-x-transition hide-on-leave class="slide-fade-enter-active">
                <v-text-field flat v-model="form.email" solo dense outlined type="email" v-bind:rules="formRules.emailRules" name="email" :placeholder="$t('emailPlaceholder')" v-bind:disabled="loading" class="input-label rounded-lg placeholder-position" prepend-inner-icon="mdi-email" color="grey"></v-text-field>
            </v-slide-x-transition>
        </v-col>
        <v-col class="my-0 py-0" cols="12">
            <v-slide-x-transition hide-on-leave class="slide-fade-enter-active">
                <v-card-text class="px-0 py-0 mb-1 text-label">
                    {{ $t("phone") }}
                    <span class="float-right secondary--text lighten-1">{{$t("optional")}}</span>
                </v-card-text>
            </v-slide-x-transition>
            <v-slide-x-transition hide-on-leave class="slide-fade-enter-active">
                <v-text-field flat v-model="form.phone" dense outlined class="input-label rounded-lg placeholder-position" solo @input="indexStore.acceptNumber()" type="tel" v-bind:rules="formRules.phoneOptionalRules" v-bind:disabled="loading" name="Phone" :placeholder="$t('phonePlaceholder')" prepend-inner-icon="mdi-phone" color="grey"></v-text-field>
            </v-slide-x-transition>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script setup>
import { computed, ref, defineExpose } from 'vue'
import { useIndexStore } from '@/store/index'
import { useUserStore } from '@/store/user'

// Variables for form validation
const contactForm = ref(null)
const contactFormValid = ref(true)

// Importing stores
const indexStore = useIndexStore()
const userStore = useUserStore()

// Computed from indexStore
const formRules = computed(() => indexStore.formRules)
const loading = computed(() => indexStore.loading)

// Computed from userStore
const form = computed({
  get: () => userStore.form,
  set: val => (userStore.form = val),
})

function validateContactForm() {
  return contactForm.value?.validate()
}

defineExpose({ validateContactForm })
</script>